<div class="wrapper" (click)="bodyClicked()">
  <div class="loading-wrap" *ngIf="isloading">
    <span class="loader"></span>
  </div>
  <div class="content-wrap">
    <app-header></app-header>
    <div class="content-body">
      <router-outlet (activate)="onActivate()"></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
  <app-checkout-bar></app-checkout-bar>
  <app-cookie-policy></app-cookie-policy>

  <!-- Whatsapp chat integration  -->
  <ng-container *ngIf="isActiveWaFeature && waNumbuer !== ''">
    <div class="contact-whatsapp" (click)="chatBoxClicked($event)">
      <div class="img-wrapper">
        <img src="assets/images/whatsapp.png" alt="Whatsapp">
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isActiveWaFeature && waNumbuer !== ''">
    <div class="whatsapp-box {{isOpenChatBox ? 'show' : ''}}" (click)="chatBoxBodyClicked($event)">
      <div class="box-wrapper">
        <div class="heading">
          <p class="lead">Welcome to {{data?.restaurant_data?.restaurant_name}}</p>
          <label>Message us on WhatsApp</label>
  
          <span class="close-icon" (click)="chatBoxClicked($event)">
            <!-- <i class="fas fa-times"></i> -->
            <i class="flaticon-unchecked" ></i>
          </span>
  
        </div>
        <div class="box-body">
          <!-- href="https://wa.me/{{waNumbuer}}?text=Hello%20{{data?.restaurant_data?.restaurant_name}}!" -->
          <a class="content-wrapper" title="whatsapp" [href]="'https://wa.me/' + waNumbuer + '?text=Hello%20' + (data?.restaurant_data?.restaurant_name || '') + '!'" target="_blank">
            <div class="img-wrapper">
              <ng-container *ngIf="data?.restaurant_data?.logo; else showDefault">
                <img src="{{data?.restaurant_data?.logo}}" 
                alt="{{data?.restaurant_data?.logo_alt_text ? data?.restaurant_data?.logo_alt_text : data?.restaurant_data?.restaurant_name}}">
              </ng-container>
              <ng-template #showDefault>
                <img src="assets/images/whatsapp.png" alt="whatsapp">
              </ng-template>
    
              <span></span>
              <span></span>
              <span></span>
              <span></span>
    
            </div>
            <div class="texts">
              <label>Support</label>
              <span>{{data?.restaurant_data?.restaurant_name}}</span>
            </div>
          </a>
        </div>
        <div class="box-footer">
          <p>Call:{{data?.restaurant_data?.business_tel}} | {{data?.restaurant_data?.email}} | {{restaurant_address}}</p>
        </div>
      </div>
    </div>
  </ng-container>
  <!-- Whatsapp chat integration  -->
</div>
